import ModelUtil from '@leverege/model-util'
import { ResponsiveModel } from '@leverege/molten/data-viewers'

const TYPE = 'ps.dataViewers.events.EventsViewModel'

function create( model, extend ) {
  return {
    ...ResponsiveModel.create( model ),

    type : TYPE,
    options : {
      perPage : 1000,
      range : 'last7Days',
    },
    allPages : false,
    getAllPages : true,
    useParent : model?.useParent,
    ...extend
  }
}

export default {
  ...ResponsiveModel,

  TYPE,
  create,
  ...ModelUtil.createAllValue( 'options/perPage', 'perPage' ),
  ...ModelUtil.createAllValue( 'options/range', 'range' ),
  ...ModelUtil.createAllValue( 'getAllPages' ),
  ...ModelUtil.createAllValue( 'useParent' )
}
